__turbopack_context__.v({
  "circle-image": "pR88vq_circle-image",
  "root": "pR88vq_root" + " " + __turbopack_context__.i(975967)["BentoCardSizeCss"],
});
